<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All OutPatient Clinics</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('outPatient-clinic create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-externalClinic' }">create</router-link>
            <!-- <router-link v-if="hasPermission('external-clinic get-delete-soft')" class="btn btn-success"
              :to="{ name: 'deleted-externalClinics' }">Deleted
              externalClinic</router-link> -->
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="externalClinics.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(externalClinic, index) in externalClinics" :key="index">
                  <th scope="row">{{ externalClinic.id }}</th>
                  <td>{{ externalClinic.name_ar }}</td>
                  <td>{{ externalClinic.name_en }}</td>
                  <!-- <td>{{ externalClinic.service.name }}</td> -->
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('outPatient-clinic delete')"
                      @click="deleteExternalClinic(externalClinic.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('outPatient-clinic update')"
                      :to="{ name: 'edit-externalClinic', params: { id: externalClinic.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No OutPatient Clinic found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import { store } from "../../Store";
import MyTable from "../MyTable//MyTable.vue";
import axios from "../../Axios";
export default {
  name: "AllExternalClinics",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      externalClinics: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
        // { label: 'Service Name', key: 'service.name' },
      ],
    };
  },

  async created() {
    this.fetchExternalClinics();
  },
  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredExternalClinics() {
      if (!this.searchTerm) {
        return this.externalClinics;
      }
      const term = this.searchTerm.toLowerCase();
      return this.externalClinics.filter(
        (externalClinic) =>
          externalClinic.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch externalClinics
    async fetchExternalClinics() {
      try {
        const response = await axios.get(
          `/admin/admin/external-clinic/all`
        );
        console.log(response);
        this.externalClinics = response.data.data;
        console.log(" fetching externalClinics:", this.externalClinics);
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching externalClinics:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteExternalClinic(id) {
      console.log("delete externalClinics id: ", id);
      axios
        .delete(`/admin/admin/external-clinic/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchExternalClinics();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>